/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React from "react";
import "./styles.scss";
import { TeamCount } from "../TeamCount/team-count";
import { RegionsList } from "../RegionsList/regions-list";

interface TeamInfoProps {
  onClick: (region: string) => void;
  activeRegion: string;
  countFallback: number;
}

export const TeamInfo = (props: TeamInfoProps): JSX.Element => {
  const { onClick, activeRegion, countFallback } = props;
  return (
    <>
      <TeamCount countFallback={countFallback ?? 0} />
      <RegionsList onClick={onClick} activeRegion={activeRegion} />
    </>
  );
};
